import React, { Suspense } from 'react'; // <-- שינוי: מייבאים את Suspense מ-React
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Suspense fallback="Loading..."> {/* <-- שינוי: הוספת עטיפת Suspense */}
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Suspense>
    </React.StrictMode>
);